import BillAddressForm from "../components/BillAddressForm";
import { Stack } from "@mui/material";
import mobileClasses from './mobile.module.css'
const BillAddress = () => {
  return (<>
    <Stack className={mobileClasses.root}>
      <BillAddressForm />
    </Stack>
  </>)
}

export default BillAddress;